import api from "./Api";

class ProdutoService {
  GetProduto(payload) {
    return api.get("/v1/Produto/" + payload).then((response) => {
      return response.data;
    });
  }

  PostProduto(payload) {
    return api.post("/v1/Produto/", payload).then((response) => {
      return response.data;
    });
  }

  PutProduto(payload) {
    return api.put("/v1/Produto/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteProduto(payload) {
    return api.delete("/v1/Produto/" + payload).then((response) => {
      return response.data;
    });
  }

  GetProdutoOData(payload) {
    return api.get("/OData/Produto" + payload).then((response) => {
      return response.data;
    });
  }

  Validate(payload) {
    return api.post("/v1/produto/Validate/", payload).then((response) => {
      return response.data;
    });
  }

  Converter(payload) {
    return api.post("/v1/produto/Converter/", payload).then((response) => {
      return response.data;
    });
  }
}

export default new ProdutoService();
